import { GridCellParams } from '@mui/x-data-grid-pro';
import { GridCustomColDef } from '../../types';
import { formatPercent, formatPrice } from '../../../utils/helpers';

export const RPMAcctRunTotalsColDefs: GridCustomColDef[] = [
  {
    field: 'rpm_run_id',
    headerName: 'Run',
    headerAlign: 'left',
    align: 'left',
    width: 80,
    type: 'singleSelect',
    valueOptions: [],
    cellClassName: 'grey-background',
    renderCell: (params: GridCellParams) => (
      <span title={`${params?.row?.run?.runMonthAbbreviation} ${params?.row?.run?.runYear}`}>
        {`${params?.row?.run?.runMonthAbbreviation} ${params?.row?.run?.runYear}`}
      </span>
    ),
    sortable: false,
    filterable: false
  },
  {
    field: 'charge_recurring_actual',
    headerName: 'MRC',
    headerAlign: 'right',
    align: 'right',
    width: 95,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_recurring_actual_percent',
    headerName: 'MRR %',
    headerAlign: 'right',
    align: 'right',
    width: 75,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPercent(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_recurring_actual',
    headerName: 'MRR',
    headerAlign: 'right',
    align: 'right',
    width: 95,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'charge_onetime_actual',
    headerName: 'NRC',
    headerAlign: 'right',
    align: 'right',
    width: 80,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_onetime_actual',
    headerName: 'One-Time',
    headerAlign: 'right',
    align: 'right',
    width: 95,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_spiff_actual',
    headerName: 'SPIFF',
    headerAlign: 'right',
    align: 'right',
    width: 80,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'revenue_trueup_actual',
    headerName: 'True-Up',
    headerAlign: 'right',
    align: 'right',
    width: 95,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && Number(params.value) < 0 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'rollup_count',
    headerName: 'Items',
    headerAlign: 'right',
    align: 'right',
    width: 70,
    flex: 0.5,
    type: 'singleSelect',
    valueOptions: [],
    sortable: false,
    filterable: false
  }
];
